const SUPPORTED_EXTENSIONS = new Set(["ai", "eps", "jpeg", "jpg", "pdf", "png", "psd", "svg", "tif", "tiff"]);

export const ACCEPTED_FILE_TYPES = ".ai, .eps, .jpeg, .jpg, .pdf, .png, .psd, .svg, .tif, .tiff";

export function getFileExtension(filename: string): string {
  const dotIndex = filename.lastIndexOf(".");
  if (dotIndex === -1) return "";
  return filename.slice(dotIndex + 1).toLowerCase();
}

export function isFileSupportedType(filename: string): boolean {
  const ext = getFileExtension(filename);
  return ext !== "" && SUPPORTED_EXTENSIONS.has(ext);
}

export function getUploadError(file: File): string | undefined {
  if (!isFileSupportedType(file.name)) {
    const ext = getFileExtension(file.name);
    return `File type ${ext ? `.${ext}` : "unknown"} is not supported. Accepted types: ${ACCEPTED_FILE_TYPES}`;
  }
}
